import React, { ReactNode } from "react";
import { Switch, Col } from "antd";
import { SwitchProps } from "antd/lib/switch";
import BaseProps from "../BaseProps/baseProps";
import { FormItemC } from "..";
import "./Switch.Component.less";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import useDirection from "src/shared/hooks/useDirection";
interface SwitchComponentProps extends SwitchProps, BaseProps {
  children?: ReactNode;
}

const SwitchComponent = (props: SwitchComponentProps) => {
  const {
    inCol = false,
    inForm = false,
    col,
    formItem,
    children,
    ...antdProps
  } = props;
  const { styler } = useDirection();
  const component = (
    <div className="SwitchComponent">
      <Switch
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        {...antdProps}
      />
      <span style={{ ...styler({ marginRight: "10px" }) }}>{children}</span>
    </div>
  );

  if (inForm && !inCol) {
    return (
      <FormItemC
        className="SwitchComponent_FormItemC"
        {...(formItem as any)}
        valuePropName="checked"
      >
        {component}
      </FormItemC>
    );
  }

  if (inCol && !inForm) {
    return <Col {...col}>{component}</Col>;
  }
  if (inCol && inForm) {
    return (
      <Col {...col}>
        <FormItemC
          className="SwitchComponent_FormItemC"
          {...(formItem as any)}
          valuePropName="checked"
        >
          {component}
        </FormItemC>
      </Col>
    );
  }
  return component;
};

export default SwitchComponent;
